/**
 * @file resetMessage.js
 * @description 초기화 확인과 완료 안내 문구를 구성합니다.
 * @used-in hooks/useSeedReset.js, services/resetMessage.test.js
 */
export const RESET_TARGET_LABELS = { content: '인사말', history: '연혁', news: '뉴스', faq: 'FAQ' };

// [기능] 현재 파일 상태와 미저장 편집 여부에 맞는 초기화 확인 문구를 반환합니다.
export function buildResetConfirmMessage(target, preview, { isDirty = false } = {}) {
  const label = RESET_TARGET_LABELS[target];
  const { exists, readable, count } = preview.current;
  const seedCount = preview.seed.count;
  let stateMessage;
  // [비즈니스] 파일 없음과 손상을 구분하고 인사말은 건수 대신 기본 문구 복원을 안내합니다.
  if (target === 'content') {
    if (!exists) stateMessage = '저장된 인사말 수정 문구가 없습니다. 기본 문구 상태로 새로 만듭니다.';
    else if (!readable) stateMessage = '현재 인사말 데이터 파일이 손상되어 읽을 수 없습니다. 기본 문구로 되돌립니다.';
    else if (count > 0) stateMessage = `현재 인사말에 저장된 수정 문구 ${count}개가 모두 지워지고 기본 문구로 돌아갑니다.`;
    else stateMessage = '현재 인사말은 이미 기본 문구입니다. 초기화해도 보이는 내용은 바뀌지 않습니다.';
  } else if (!exists) {
    stateMessage = `저장된 ${label} 데이터 파일이 없습니다. 초기 데이터 ${seedCount}건으로 만듭니다.`;
  } else if (!readable) {
    stateMessage = `현재 ${label} 데이터 파일이 손상되어 읽을 수 없습니다. 초기 데이터 ${seedCount}건으로 바꿉니다.`;
  } else {
    stateMessage = `현재 ${label} ${count}건이 초기 데이터 ${seedCount}건으로 바뀝니다.`;
  }
  const messages = [stateMessage];
  // [비즈니스] 뉴스 탭에는 되돌리기 버튼이 없어 비교 안내를 생략합니다.
  if (target !== 'news') messages.push("'되돌리기'는 마지막 저장 상태로 돌아가지만, '초기화'는 저장된 데이터까지 처음 제공된 초기 데이터로 바꿉니다.");
  // [비즈니스] 저장 전 초안도 사라지며 뉴스 이미지 파일은 삭제하지 않습니다.
  if (isDirty) messages.push('저장하지 않은 편집 내용도 함께 사라집니다.');
  if (target === 'news') messages.push('본문에 올린 이미지 파일은 서버에 그대로 남습니다.');
  if (exists) messages.push('초기화 직전의 현재 파일은 서버의 백업 폴더(data/backups)에 보관됩니다.');
  return messages.join(' ');
}

// [기능] 적용 결과와 백업 파일명을 담은 초기화 완료 안내를 반환합니다.
export function buildResetDoneMessage(target, result) {
  let message = target === 'content'
    ? '인사말 초기화를 마쳤습니다. 기본 문구가 적용되었습니다.'
    : `${RESET_TARGET_LABELS[target]} 초기화를 마쳤습니다. 초기 데이터 ${result.count}건이 적용되었습니다.`;
  // [비즈니스] 현재 파일이 없었다면 백업이 없으므로 보관 안내도 생략합니다.
  if (result.backup) message += ` 이전 데이터는 백업 파일(${result.backup})로 보관했습니다.`;
  return `${message} 공개 페이지는 새로고침하면 반영됩니다.`;
}
